$(function() {
    $('.open-search').click(function() {
        $('.search-bar').addClass('open');
    });
    $('.close-search').click(function() {
        $('.search-bar').removeClass('open');
    });
});
